
<app-shared [type]="'bon-transfert'" [status]="'En cours'"></app-shared>
